module.exports = __webpack_public_path__ + "static/img/outbound_link.75de1af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/outbound_link.png
// module id = DJEk
// module chunks = 1